/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional name of the study program for context.
 */
export type ContentStudioConfigStudyProgram = string | null;
